import axios from "axios";
import { DataTable, Project, Tool } from "graphql/_Types";
import { getEnvVar } from "ideas.env";
import { ToolSpecV3 } from "types/json-schemas/ToolSpecV3";
import { getRequestHeaders } from "utils/getRequestHeaders";

/**
 * Request tool version info from backend
 */
export const getToolVersionToolEditor = async (toolVersionId: number) => {
  const headers = await getRequestHeaders();
  const res = await axios.get<{
    id: number;
    draft_tool_spec: ToolSpecV3 | null;
    is_draft_spec_synced: boolean | null;
    tool: {
      id: Tool["id"];
      key: Tool["key"];
      help_text: Tool["helpText"];
      project: {
        id: Project["id"];
        key: Project["key"];
      };
    };
    test_table: Pick<DataTable, "id" | "key"> | null;
    publish_options:
      | { first_version: string }
      | { major: string; minor: string; patch: string };
    has_container_image: boolean;
  }>(getEnvVar("URL_TRS_TOOL_VERSION_TOOL_EDITOR")(toolVersionId), {
    headers,
  });

  return {
    draft_spec: res.data.draft_tool_spec,
    hasCode: res.data.draft_tool_spec !== null,
    tool: res.data.tool,
    isDraftSpecSynced: res.data.is_draft_spec_synced,
    publishOptions: res.data.publish_options,
    test_table: res.data.test_table,
    hasContainerImage: res.data.has_container_image,
  };
};
